import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-warning",
  "use": "icon-warning-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-warning\">\n<path d=\"M10.2442 3.21895C11.0022 1.82922 12.9978 1.82922 13.7558 3.21895L22.3867 19.0423C23.1137 20.375 22.149 22 20.6309 22H3.36908C1.85097 22 0.886339 20.375 1.61329 19.0423L10.2442 3.21895Z\" fill=\"#FF8541\" />\n<path d=\"M12 12L12 18\" stroke=\"white\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\n<circle cx=\"12\" cy=\"9\" r=\"1\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol